import React from "react";
import { useNavigate } from "react-router-dom";
import classes from "./styles/JobCard.module.css";

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const now = new Date();
  const diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));
  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "1 day ago";
  if (diffDays < 7) return `${diffDays} days ago`;
  if (diffDays < 30) return `${Math.floor(diffDays / 7)}w ago`;
  return date.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
};

const stripHtml = (html) => {
  if (!html) return "";
  return html.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
};

const JobCard = ({ job, country }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/job/description/${job._id || job.JobId}?country=${encodeURIComponent(country || "")}`);
  };

  const summaryText = stripHtml(job.summary || job.description || "");
  const shortSummary = summaryText.length > 160 ? summaryText.slice(0, 160).trim() + "…" : summaryText;

  return (
    <div
      className={classes.card}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && handleClick()}
    >
      <div className={classes.topRow}>
        {/* Logo placeholder */}
        <div className={classes.logoBox}>
          {job.company ? job.company.charAt(0).toUpperCase() : "J"}
        </div>

        <div className={classes.topInfo}>
          <h3 className={classes.jobTitle}>{job.title}</h3>
          <div className={classes.meta}>
            {job.company && (
              <span className={classes.metaItem}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <rect x="2" y="7" width="20" height="14" rx="2"/>
                  <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
                </svg>
                {job.company}
              </span>
            )}
            {job.location && (
              <span className={classes.metaItem}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                {job.location}
              </span>
            )}
            {job.datePosted && (
              <span className={classes.metaItem}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12 6 12 12 16 14"/>
                </svg>
                {formatDate(job.datePosted)}
              </span>
            )}
          </div>
          {shortSummary && (
            <p className={classes.summary}>{shortSummary}</p>
          )}
        </div>

        <svg className={classes.arrow} width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <path d="M9 18l6-6-6-6"/>
        </svg>
      </div>

      
    </div>
  );
};

export default JobCard;
